import { Component, OnInit } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { AnamneseService } from 'src/app/admihair/service/anamnese.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Anamnese } from 'src/app/admihair/api/dto/anamnese';

@Component({
  selector: 'app-anamnese-configuracao-editar',
  templateUrl: './anamnese-configuracao-editar.component.html',
  styleUrls: ['./anamnese-configuracao-editar.component.scss']
})
export class AnamneseConfiguracaoEditarComponent extends AdmihairBaseComponent implements OnInit {

  loading: boolean = true;
  anamnese?: Anamnese;
  progressoRequisicao: boolean = false;
  
  constructor(private anamneseService: AnamneseService,
      erroService: ErroService,
      storageService: UtilStorageService,
      router: Router,
      activatedRoute: ActivatedRoute) {
        super(erroService, storageService, router, activatedRoute)
       }

  ngOnInit(): void {
    this.carregarIdUrl();
    this.carregarConfiguracaoAnamnese();
  }

  carregarConfiguracaoAnamnese() {
    this.anamneseService.buscarPorId(this.idParametroUrl).subscribe({
      next: (data: Anamnese) => {
        this.anamnese = data;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  atualizar() {
    this.progressoRequisicao = true;
    this.anamneseService.atualizar(this.idParametroUrl, this.anamnese).subscribe({
      next: (data: Anamnese) => {
        this.anamnese = data;
        this.progressoRequisicao = false;
        this.exibirMensagemSucesso();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.exibirMensagemErro(err);
      }
    })
  }


  

}
